/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maroon_Suave_Herring_GreetInputs */

const fr_maroon_suave_herring_greet = /** @type {(inputs: Maroon_Suave_Herring_GreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

/**

* @param {Maroon_Suave_Herring_GreetInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const maroon_suave_herring_greet = /** @type {((inputs?: Maroon_Suave_Herring_GreetInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maroon_Suave_Herring_GreetInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_maroon_suave_herring_greet(inputs)
});